module.exports = __webpack_public_path__ + "static/media/Example of Projects.5a98ffe5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Example of Projects.csv
// module id = 761
// module chunks = 0